export const ExpiredChip = (): JSX.Element => (
  <div className="flex w-fit items-center rounded-full bg-gray-80 px-3 py-1 text-center text-sm text-font-subtle">
    Expired
  </div>
);
